import {
  fetchListCity,
  fetchListDistrict,
  fetchListWard,
} from "@/apis/queryFunctions/address";
import { SelectComponent } from "@/common/components";
import useUserInfo from "@/hooks/useUserInfo";
import { CartContext } from "@/setup/cartProvider";
import {
  Box,
  Checkbox,
  createStyles,
  Modal,
  SimpleGrid,
  Text,
  UnstyledButton,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useMediaQuery } from "@mantine/hooks";

import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import FormAddress from "./FormAddress";

const useStyles = createStyles((theme) => ({
  buttonSelected: {
    flex: 1,
    marginBottom: theme.spacing.sm,
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width: 720px)": {
      flexDirection: "column",
    },
  },
  containerSelected: {
    flex: 1,
    flexDirection: "row",
    display: "flex",
    border: "1px solid #e6e6e6",
    padding: "1.2rem",
    borderRadius: "0.5rem",
    // "@media (max-width: 1200px)": {
    //   width: "100%",
    // },
  },
  checkedButtonAddressSelected: {
    paddingRight: 10,
    paddingTop: 10,
  },
  buttonEditAddress: {
    paddingLeft: 10,
    paddingTop: 10,
  },
}));

function AddressSection() {
  const {
    setUserInfo,
    addressSelected,
    fetchShipAddress,
    listAddress,
    updateAddressSelected,
  } = useContext(CartContext);

  const { isLogin } = useUserInfo();

  const [isEditAddress, setIsEditAddress] = useState(null); // 2: add new address, 1: edit address

  const { classes } = useStyles();

  const isMobile = useMediaQuery("(max-width: 600px)");

  useEffect(() => {
    fetchShipAddress();
  }, []);

  //debounce set state

  const onChangeAddressSelected = (value) => {
    const address = listAddress?.find((item) => item._id === value);
    updateAddressSelected(address);
  };

  const editAddress = () => {
    if (isEditAddress === 1) {
      setIsEditAddress(null);
      return;
    }
    setIsEditAddress(1);
  };

  const addNewAddress = async () => {
    setIsEditAddress(2);
    setUserInfo({
      ten_nguoi_nhan: "",
      sdt_nguoi_nhan: "",
      email_nguoi_nhan: "",
      tinh_thanh: "",
      quan_huyen: "",
      xa_phuong: "",
      dia_chi: "",
    });
  };

  const selectedAddress = () => {
    onChangeAddressSelected(addressSelected);
    setIsEditAddress(1);
  };

  return (
    <>
      {listAddress?.length > 0 && isLogin !== false && (
        <SimpleGrid className={classes.buttonSelected}>
          <Box className={classes.containerSelected}>
            <Box className={classes.checkedButtonAddressSelected}>
              <Checkbox
                onChange={selectedAddress}
                checked={!(isEditAddress === 2)}
              />
            </Box>
            <Box>
              <SelectComponent
                valueDefault={addressSelected?._id}
                data={listAddress}
                valueKey="_id"
                labelKey="ten_nguoi_nhan"
                onChange={onChangeAddressSelected}
                sx={{ marginBottom: 10, flex: 1 }}
              />
              <Text>{addressSelected.ten_nguoi_nhan}</Text>
              <Text>{addressSelected.sdt_nguoi_nhan}</Text>
              <Text>{addressSelected.dia_chi}</Text>
              <Text>
                {addressSelected.xa_phuong}, {addressSelected.quan_huyen},{" "}
                {addressSelected.tinh_thanh}
              </Text>
            </Box>
            <Box className={classes.buttonEditAddress}>
              <UnstyledButton onClick={editAddress}>Sửa</UnstyledButton>
            </Box>
          </Box>
          <UnstyledButton
            sx={{
              flex: 1,
              border: "1px solid #e6e6e6",
              padding: "1.2rem",
              borderRadius: "0.5rem",
              display: "flex",
              justifyContent: "start",
            }}
            onClick={addNewAddress}
          >
            <Checkbox
              // onChange={addNewAddress}
              checked={isEditAddress === 2}
              label="Thêm địa chỉ mới"
            />
          </UnstyledButton>
        </SimpleGrid>
      )}

      <Modal
        size="lg"
        fullScreen={isMobile}
        opened={isEditAddress}
        onClose={() => setIsEditAddress(null)}
      >
        <FormAddress
          setIsShow={setIsEditAddress}
          addressSelected={isEditAddress === 1 ? addressSelected : null}
        />
      </Modal>

      {(!addressSelected?._id || isLogin === false) && (
        <>
          <FormAddress setIsShow={setIsEditAddress} />
        </>
      )}
    </>
  );
}

export default AddressSection;
